var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonExtensions = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M28 37.984h-7.998v-.017 4.046a1.988 1.988 0 01-3.975 0v-4.045.016h-2.055a3.958 3.958 0 01-3.958-3.958v-2.049h.023-4.05a1.988 1.988 0 010-3.974h4.046-.024v-8.001h.024-4.046a1.988 1.988 0 010-3.977h4.046-.024v-2.048a3.958 3.958 0 013.958-3.959h2.056v.017-4.048a1.988 1.988 0 013.974 0v4.046-.017h7.999v.017-4.046a1.988 1.988 0 013.974 0v4.046-.017h2.049a3.958 3.958 0 013.958 3.958v2.049h-.014 4.045a1.988 1.988 0 010 3.974h-4.045.014v7.999h-.014 4.045a1.988 1.988 0 010 3.974h-4.045.014v2.049a3.958 3.958 0 01-3.958 3.958H31.97v-.017 4.046a1.988 1.988 0 01-3.974 0V37.96", fill: fills.light }),
        React.createElement("path", { d: "M19.008 16.01h9.979a3.003 3.003 0 013.002 3.003v9.974a3.003 3.003 0 01-3.002 3.002h-9.979a3.003 3.003 0 01-3.002-3.002v-9.974a3.003 3.003 0 013.002-3.002z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
